import React from 'react';
import { useNavigate } from 'react-router';
import { useAtomValue } from 'jotai';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { currentContextAtom } from '../../state';
import { ServiceConfigurations } from '../../company/services/state';
import ServiceCard from '../../company/services/ServiceCard';
import { RoutePaths } from '../../routes/AppRoutes';
import { SettingsDialogViewProps } from './SettingsDialog';

interface ServicesSettingsProps extends SettingsDialogViewProps{
  close: () => void;
}

export default function ServicesSettings({
  next,
  close,
}: ServicesSettingsProps): React.JSX.Element {
  const { t } = useTranslation(['settings', 'common']);
  const navigate = useNavigate();
  const { companyServices } = useAtomValue(currentContextAtom);

  const handleSubmit = (): void => {
    navigate(RoutePaths.COMPANY_SERVICES);
    close();
  }

  return (
    <>
      <DialogTitle>
        <Box sx={{ display: 'flex' }}>
          <Typography sx={{ flex: 1 }}>
            {t('settings:your_services')}
          </Typography>
        </Box>
        <Typography>{t('settings:your_services_description')}</Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
            },
            gap: 2,
          }}
        >
          {ServiceConfigurations.map((configuration) => (
            <ServiceCard
              key={configuration.service}
              configuration={configuration}
              companyServices={companyServices}
              readOnly
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => next({ skipped: true, noRedirect: true })} variant="outlined">
          {t('settings:complete_later')}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
        >
          {t('settings:define_my_services')}
        </Button>
      </DialogActions>
    </>
  );
}